import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { SERVICES, PHONE, PHONE_HREF } from "@/data/site";

export default function Services() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Services - Remodeling, Custom Homes, Roofing | McMullen"
        description="Residential remodels, custom home building and additions, metal, tile and shingle roofing, and design & engineering from a State certified Florida general contractor."
      />
      <PageHero
        testId="services-hero"
        eyebrow="Our Services"
        lines={["Remodel & new construction,", "done to a higher standard."]}
        intro="From whole-home renovations to ground-up custom builds, roofing, and design & engineering - every project is delivered by a State certified general contractor."
      />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 pb-20 sm:pb-28 space-y-20" data-testid="services-list">
        {SERVICES.map((s, i) => (
          <div key={s.id} className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" data-testid={`service-block-${s.id}`}>
            <Reveal className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="gold-frame-offset">
                <img src={s.image} alt={s.title} loading="lazy" className="relative z-10 h-72 sm:h-96 w-full object-cover img-spotlight" />
              </div>
            </Reveal>
            <Reveal delay={0.12} className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <p className="font-mono-accent text-xs tracking-[0.3em] text-[#8A7322]">SERVICE - 0{i + 1}</p>
              <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F3E081]">{s.title}</h2>
              <p className="mt-5 text-sm sm:text-base leading-relaxed text-[#A1A1AA] max-w-xl">{s.blurb}</p>
              <ul className="mt-6 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-3 text-sm text-[#C9C7C2]">
                    <Check className="h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" /> {p}
                  </li>
                ))}
              </ul>
              <Link
                to="/contact"
                data-testid={`service-cta-${s.id}`}
                className="mt-8 inline-flex items-center gap-2 border border-[rgba(212,175,55,0.5)] px-6 py-3 text-xs uppercase tracking-[0.2em] text-[#F3E081] hover:bg-[rgba(212,175,55,0.1)] transition-colors duration-300"
              >
                Discuss this project <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </Reveal>
          </div>
        ))}
      </section>

      <section className="bg-ink-2 border-t border-[rgba(212,175,55,0.15)] py-20 text-center" data-testid="services-cta-section">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <Reveal>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F4F2EE]">Not sure where to start?</h2>
          </Reveal>
          <Reveal delay={0.12}>
            <p className="mt-4 text-sm sm:text-base text-[#A1A1AA]">
              Call us and talk it through - <a href={PHONE_HREF} className="text-[#F3E081] hover:text-[#D4AF37] transition-colors" data-testid="services-phone-link">{PHONE}</a>
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
